import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody, Table, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faEye, faTimes, faBed, faPhoneAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import amb1 from "./../../assets/RestHouses/Ambala/1.jpg";
import amb2 from "./../../assets/RestHouses/Ambala/2.jpg";
import amb3 from "./../../assets/RestHouses/Ambala/3.jpg";
import bh1 from "./../../assets/RestHouses/Bhiwani/1.jpeg";
import ga1 from "./../../assets/RestHouses/Gurugram/1.jpeg";
import ji1 from "./../../assets/RestHouses/Jind/1.jpg";
import ji2 from "./../../assets/RestHouses/Jind/2.jpg";
import ku1 from "./../../assets/RestHouses/Kurukshetra/1.JPG";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const data = [
    { location: 'Ambala Cantt', address: 'Sainik Rest House, Mall Road', nearestRlyStn: 'Ambala Cantt', offrs: 4, jcos: 4, ors: 1, contactNo: '0171-2643951', images: [amb1,amb2,amb3] },
    { location: 'Ambala City', address: 'Sainik Rest House, Near Badsahi Bagh Gurdwara', nearestRlyStn: 'Ambala City', offrs: 'Used by ZSB Office', jcos: '-', ors: '-', contactNo: '0171-2640557', images: [] },
    { location: 'Ateli', address: 'Sainik Rest House, Near BDO Office', nearestRlyStn: 'Ateli (M\'Garh)', offrs: 1, jcos: 1, ors: 1, contactNo: '01282-250259', images: [] },
    { location: 'Bahadurgarh', address: 'Sainik Rest House, Delhi - Rohatak Road', nearestRlyStn: 'Bahadurgarh(Jhajjar)', offrs: 2, jcos: 2, ors: 1, contactNo: '01251-254236' , images: []},
    { location: 'Bhiwani', address: 'Sainik Rest House, Railway Road, Near DAV College', nearestRlyStn: 'Bhiwani', offrs: 3, jcos: 2, ors: 1, contactNo: '01664-243538', images: [bh1] },
    { location: 'Charkhi Dadri', address: 'Sainik Rest House, Near Civil Court Complex', nearestRlyStn: 'Charkhi Dadri', offrs: 1, jcos: 1, ors: 1, contactNo: '01664-243538', images: [] },
    { location: 'Faridabad', address: 'Sainik Rest House, Near Old Sabji Mandi Sector 16', nearestRlyStn: 'Faridabad', offrs: 2, jcos: 2, ors: 1, contactNo: '0129-2589089' , images: []},
    { location: 'Gohana', address: 'Sainik Rest House, Near ITI, Gohana(Sonepat)', nearestRlyStn: 'Gohana', offrs: 2, jcos: 1, ors: 1, contactNo: '0130-2242659', images: [] },
    { location: 'Gurgaon', address: 'Sainik Rest House, Apna Bazar, Old Delhi-Alwar Road Civil Lines', nearestRlyStn: 'Gurgaon', offrs: 3, jcos: 3, ors: 1, contactNo: '0124-2320730', images: [ga1] },
    { location: 'Hisar', address: 'Sainik Rest House, Near PWD Rest House', nearestRlyStn: 'Hisar', offrs: 4, jcos: 3, ors: 1, contactNo: '01662-272901', images: [] },
    { location: 'Jhajjar', address: 'Sainik Rest House, Gudiani Road', nearestRlyStn: 'Jhajjar', offrs: 2, jcos: 1, ors: 1, contactNo: '01251-254236', images: [] },
    { location: 'Jind', address: 'Sainik Rest House, Near Bus Stand', nearestRlyStn: 'Jind', offrs: 2, jcos: 1, ors: 1, contactNo: '01681-245254', images: [ji1,ji2] },
    { location: 'Kaithal', address: 'Sainik Rest House, H. No. 761, Amargarh Basti, Opp Gali No. 3', nearestRlyStn: 'Kaithal', offrs: '--', jcos: 1, ors: 1, contactNo: '01746-223731' , images: []},
    { location: 'Kanina', address: 'Sainik Rest House, Near BDO Office, M\'Garh - Rewari Road', nearestRlyStn: 'Kanina', offrs: 1, jcos: 1, ors: 1, contactNo: '01282-250259', images: [] },
    { location: 'Karnal(Old)', address: 'Sainik Rest House, Near Karan Park', nearestRlyStn: 'Karnal', offrs: 2, jcos: 1, ors: 1, contactNo: '0184-2272589', images: [] },
    { location: 'Karnal(New)', address: 'Sainik Rest House, Near Karan Park', nearestRlyStn: 'Karnal', offrs: 'Use Of ZSB Office', jcos: '-', ors: '-', contactNo: '0184-2272589', images: [] },
    { location: 'Kosli', address: 'Sainik Rest House, Near SDO (C) Office', nearestRlyStn: 'Kosli', offrs: '--', jcos: '--', ors: '--', contactNo: '01274-224341' , images: []},
    { location: 'Kurukshetra', address: 'Sainik Rest House, Urban Estate, Section 13', nearestRlyStn: 'Kurukshetra', offrs: 1, jcos: 1, ors: 1, contactNo: '01744-220922', images: [ku1] },
    { location: 'Loharu', address: 'Sainik Rest House, Near Bus Stand', nearestRlyStn: 'Loharu (Bhiwani)', offrs: 2, jcos: 2, ors: 1, contactNo: '01664-243538', images: [] },
    { location: 'Mohindergarh', address: 'Sainik Rest House, Near Civil Court', nearestRlyStn: 'Mohindergarh', offrs: 1, jcos: 1, ors: 1, contactNo: '01282-250259' , images: []},
    { location: 'Narnaul', address: 'Sainik Rest House, Near PWD Rest House', nearestRlyStn: 'Narnaul (M\'Garh)', offrs: 3, jcos: 2, ors: 1, contactNo: '01282-250259', images: [] },
    { location: 'Panipat', address: 'Sainik Rest House, Kothi No. 228, Adarsh Nagar', nearestRlyStn: 'Panipat', offrs: 1, jcos: 1, ors: 1, contactNo: '0180-2650311', images: [] },
    { location: 'Panchkula', address: 'Sainik Rest House, Sector 12', nearestRlyStn: 'Panchkula', offrs: 4, jcos: 3, ors: 1, contactNo: '0172-2584213', images: [] },
    { location: 'Rewari', address: 'Sainik Rest House, Opp Girls Sr. Sec School', nearestRlyStn: 'Rewari', offrs: 2, jcos: 1, ors: 1, contactNo: '01274-224341', images: [] },
    { location: 'Rohtak(Old)', address: 'Sainik Rest House, Near Chottu RamChowk, Civil Road', nearestRlyStn: 'Rohtak', offrs: 'Use Of ZSB Office', jcos: '--', ors: '--', contactNo: '01262-230687', images: [] },
    { location: 'Rohtak(New)', address: 'Sainik Rest House, Near Chottu Ram Chowk, Civil Road', nearestRlyStn: 'Rohtak', offrs: 4, jcos: 3, ors: 1, contactNo: '01262-230687' , images: []},
    { location: 'Sirsa', address: 'Sainik Rest House, Opp Police Line Barnala Road', nearestRlyStn: 'Sirsa', offrs: 1, jcos: 1, ors: 1, contactNo: '01666-247339', images: [] },
    { location: 'Sonepat', address: 'Sainik Rest House, Police Line, Gohana Road', nearestRlyStn: 'Sonepat', offrs: 2, jcos: 2, ors: 1, contactNo: '0130-2220659', images: [] },
    { location: 'Yamuna Nagar', address: 'District Sainik and Ardh Sainik Welfare Office ( Sainik Rest House), Yamuna Nagar. Behind Panchayat Bhawan, Vill - Govindpura, Tehsil: Jagadhri, PO: Mini Sectt, Jagadhri District: Yamuna Nagar, PIN-135003', nearestRlyStn: 'Yamuna Nagar', offrs: 3, jcos: 2, ors: 1, contactNo: '01732-211892, 01732-222072', images: [] },
  ];

  const SainikRestHouses = () => {
    const [modalShow, setModalShow] = useState(false);
    const [selectedRestHouse, setSelectedRestHouse] = useState(null);
  
    const handleShowModal = (restHouse) => {
      setSelectedRestHouse(restHouse);
      setModalShow(true);
    };
  
    const handleCloseModal = () => {
      setModalShow(false);
      setSelectedRestHouse(null);
    };
  
    return (
      <>
        <div style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '30px 0',
          color: 'white',
          margin: '2%',
          borderRadius: '10px'
        }}>
          <Container>
            <h3 className="fw-bold mb-0 text-center">
              <FontAwesomeIcon icon={faHome} className="me-2" />
              Sainik Rest House across the State of Haryana
            </h3>
          </Container>
        </div>

        <Container className="py-5">
          <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
            <div style={{
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              padding: '25px',
              color: 'white'
            }}>
              <h4 className="fw-bold mb-0">
                <FontAwesomeIcon icon={faHome} className="me-2" />
                Rest House Directory
              </h4>
            </div>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead>
                    <tr>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '5%' }}>Sr. No.</th>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '15%' }}>Location</th>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '20%' }}>Address</th>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Nearest Rly Stn</th>
                      <th colSpan={3} style={{ background: '#16a085', color: 'white' }}>Accommodation Available(Rooms)</th>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Contact No.</th>
                      <th rowSpan={2} style={{ background: '#1e3c72', color: 'white', width: '5%' }}>Images</th>
                    </tr>
                    <tr>
                      <th style={{ background: '#16a085', color: 'white', width: '5%' }}>Offrs</th>
                      <th style={{ background: '#16a085', color: 'white', width: '5%' }}>JCOs</th>
                      <th style={{ background: '#16a085', color: 'white', width: '5%' }}>ORs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td style={{ color: '#495057' }}>{index + 1}</td>
                        <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.location}</td>
                        <td style={{ color: '#495057' }}>{item.address}</td>
                        <td style={{ color: '#495057' }}>{item.nearestRlyStn}</td>
                        <td style={{ color: '#495057' }}>{item.offrs}</td>
                        <td style={{ color: '#495057' }}>{item.jcos}</td>
                        <td style={{ color: '#495057' }}>{item.ors}</td>
                        <td style={{ color: '#495057' }}>
                          <FontAwesomeIcon icon={faPhone} className="me-2" style={{ color: '#1e3c72' }} />
                          {item.contactNo}
                        </td>
                        <td className="text-center">
                          {item.images.length !== 0 ? (
                            <Button 
                              style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '6px 15px',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}
                              onClick={() => handleShowModal(item)}
                              onMouseOver={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                e.currentTarget.style.transform = 'scale(1.05)';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} className="me-2" />
                              View
                            </Button>
                          ) : (
                            <span style={{ color: '#6c757d' }}>-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Container>
        {selectedRestHouse && (
          <Modal isOpen={modalShow} toggle={handleCloseModal} size="lg" centered>
            <ModalHeader 
              toggle={handleCloseModal}
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none'
              }}
            >
              <FontAwesomeIcon icon={faHome} className="me-2" />
              Sainik Rest House <span style={{color: '#fff'}}>{selectedRestHouse.location}</span> Images
            </ModalHeader>
            <ModalBody className="p-0">
              <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                  {selectedRestHouse.images.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying"
                      data-bs-slide-to={idx}
                      className={idx === 0 ? 'active' : ''}
                      aria-current={idx === 0 ? 'true' : 'false'}
                      aria-label={`Slide ${idx + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {selectedRestHouse.images.map((image, index) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                      <img 
                        src={image} 
                        className="d-block mx-auto" 
                        alt={`image-${index}`} 
                        style={{
                          height: '350px',
                          width: 'auto',
                          maxWidth: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  ))}
                </div>
                <button 
                  className="carousel-control-prev" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="prev"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-prev-icon " aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button 
                  className="carousel-control-next" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="next"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
              <Button
                style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 25px',
                  fontWeight: '600'
                }}
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  };

export default SainikRestHouses;